import { render } from "./News2526FW.vue?vue&type=template&id=876f139e&scoped=true"
import script from "./News2526FW.vue?vue&type=script&lang=js"
export * from "./News2526FW.vue?vue&type=script&lang=js"

import "./News2526FW.vue?vue&type=style&index=0&id=876f139e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-876f139e"]])

export default __exports__